module.exports = __webpack_public_path__ + "static/CV2019-c469f32f2596313f8f379923016cccea.pdf";